export const CONFIG_CDN_URL = 'https://lnesv3-conf.ado-tech.com';

export const PLATFORMS = {
    IOS: 'ios',
    ANDROID: 'android',
    REACT_NATIVE: 'react-native',
    WEB: 'web'
};

export const ACTIONS = {
    PASSIVE: 'video_selfie_blank',
    TURN_LEFT: 'video_selfie_left',
    TURN_RIGHT: 'video_selfie_right',
    LOOK_DOWN: 'video_selfie_down',
    LOOK_UP: 'video_selfie_high',
    SMILE: 'video_selfie_smile',
    BLINK: 'video_selfie_eyes',
    SCAN: 'video_selfie_scan'
};

export const DEFAULT_STYLE = {
    baseColorCustomization: {
        textColorPrimary: '#000000',
        backgroundColorPrimary: '#FFFFFF',
        textColorSecondary: '#8E8E93',
        backgroundColorSecondary: '#F2F2F7',
        iconColor: '#00A5BA'
    },
    baseFontCustomization: {
        textFont: 'Roboto, sans-serif',
        textSize: '16px',
        textWeight: '400',
        textStyle: 'normal'
    },
    titleFontCustomization: {
        textFont: 'inherit',
        textSize: '36px',
        textWeight: '500',
        textStyle: 'normal'
    },
    buttonCustomization: {
        textFont: 'inherit',
        textSize: '14px',
        textWeight: '500',
        textStyle: 'normal',
        textColorPrimary: '#FFFFFF',
        backgroundColorPrimary: '#00A5BA',
        textColorSecondary: '#00A5BA',
        backgroundColorSecondary: '#DBF2F5',
        cornerRadius: '10px'
    },
    toolbarCustomization: {
        closeButtonIcon: 'cross',
        iconColor: '#707070'
    },
    centerHintCustomization: {
        textFont: 'inherit',
        textSize: '24px',
        textWeight: '500',
        textStyle: 'normal',
        textColor: '#FFFFFF',
        backgroundColor: '#1C1C1E',
        backgroundOpacity: '56%',
        backgroundCornerRadius: '14px',
        verticalPosition: '38%'
    },
    hintAnimation: {
        hideAnimation: false,
        hintGradientColor: '#00BCD5',
        hintGradientOpacity: '100%',
        animationIconSize: '80px'
    },
    faceFrameCustomization: {
        geometryType: 'oval',
        cornersRadius: '0px',
        strokeDefaultColor: '#D51900',
        strokeFaceInFrameColor: '#00BCD5',
        strokeOpacity: '100%',
        strokeWidth: '6px',
        strokePadding: '4px'
    },
    backgroundCustomization: {
        backgroundColor: '#FFFFFF',
        backgroundOpacity: '88%'
    },
    maskCustomization: {
        maskColor: '#008700',
        glowColor: '#000102',
        minAlpha: '30%',
        maxAlpha: '100%'
    },
    loaderTransition: {
        type: 'fade',
        duration: 500
    }
};

export const DEFAULT_LOCALIZATION = {
    oz_action_blank_go: 'Centra tu rostro en el óvalo',
    oz_action_smile_go: 'Sonríe',
    oz_action_eyes_go: 'Parpadea',
    oz_action_down_go: 'Mira hacia abajo',
    oz_action_high_go: 'Mira hacia arriba',
    oz_action_left_go: 'Gira a la izquierda',
    oz_action_right_go: 'Gira a la derecha',
    oz_action_scan_go: 'Gira lentamente tu cabeza',
    oz_hint_face_centering: 'Centra tu rostro',
    oz_hint_face_too_close: 'Aléjate un poco',
    oz_hint_face_too_far: 'Acércate más',
    oz_hint_face_not_found: 'Rostro no detectado',
    oz_hint_hold_steady: 'Mantente quieto',
    oz_status_processing: 'Procesando...',
    oz_status_uploading: 'Enviando...',
    oz_error_camera_access: 'No se pudo acceder a la cámara',
    oz_error_timeout: 'Tiempo agotado, intenta de nuevo',
    oz_button_start: 'Comenzar',
    oz_button_retry: 'Reintentar',
    oz_button_cancel: 'Cancelar'
};
